import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class Radio extends React.Component {
  static displayName = 'Radio';
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: null,
    checked: false,
    value: null,
    onChange: () => true,
  };

  isSelected() {
    return !!this.props.checked;
  }

  getStyle() {
    if (this.isSelected() && this.props.indicatorStyle === 'radio') {
      return { 'af-radio': true };
    } else if (this.isSelected() && this.props.indicatorStyle !== 'radio') {
      return { 'af-checkmark': true };
    }
    return {};
  }

  clicked(e) {
    e.preventDefault();
    // You cannot "un-select" this radio. It's only "un-selected" if another
    // radio is selected. Used only in a "mutually exclusive" list of radios.
    this.props.onChange(this.props.value);
  }

  render() {
    let wrapperClasses = classnames('Radio', this.props.className);
    let radioIndicatorClass = this.props.checked
      ? 'Radio-indicator active'
      : 'Radio-indicator';
    let indicatorClasses = classnames(
      'Checkmark-indicator-fill',
      this.getStyle()
    );
    let inputId = this.props.id ? { id: this.props.id } : {};

    return (
      <div className={wrapperClasses} onClick={this.clicked.bind(this)}>
        <input
          {...inputId}
          type="radio"
          value={this.props.checked}
          defaultChecked={this.props.checked}
          style={{ display: 'none' }}
        />

        <span className={radioIndicatorClass}>
          <span className={indicatorClasses} data-testid="radio-button"></span>
        </span>
      </div>
    );
  }
}
